<script>
    import {getContext, onMount} from "svelte";
    import {FlatToast, ToastContainer, toasts} from "svelte-toasts";
    import CommentFormComponent from "./CommentFormComponent.svelte";
    import { tick } from 'svelte';
    import CommentContent from "./CommentContent.svelte";

    const { open } = getContext('simple-modal');

    export let model_root;
    export let cid;
    export let cname;

    let comments = undefined;

    let answerToComment = {
        id: null,
        preview: ""
    }

    onMount(() => {
        loadComments();
    })

    const fetchComments = () => {
        return fetch(model_root + 'shared/contents/comments/load_comments.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const loadComments = () => {
        comments = undefined;
        fetchComments().then(data => {
            comments = Object.values(data);
        })
    }

    const replyToComment = async (id, content) => {
        answerToComment.id = id;
        answerToComment.preview = content.replace(/<[^>]*>?/gm, '').split(/\s+/).slice(0,6).join(" ") + " ...";
        await tick();
        scrollIntoView("#write-comment");
    }

    const scrollIntoView = (href) => {
        const el = document.querySelector(href);
        if (!el) return;
        el.scrollIntoView({
            behavior: 'smooth'
        });
    }

</script>

<ToastContainer placement="bottom-right"
                showProgress="true"
                let:data={data}>
    <FlatToast {data} />
</ToastContainer>

<h5 class="mb-1 mt-1 text-muted">Kommentare</h5>
<h3 class="mb-3">{@html cname}</h3>

{#if comments === undefined}
    <p class="mt-4 mb-4"><i class="fas fa-circle-notch fa-spin"></i> Kommentare werden geladen...</p>
{:else}
    {#if comments.length === 0}
        <div class="bg-light rounded p-3 mb-3">
            <i class="fas fa-info-circle me-1"></i> Noch keine Kommentare vorhanden
        </div>
    {/if}

    {#each comments as comment, index}
        <div class="bg-light rounded p-3 mb-3">
            <CommentContent {model_root} {comment} reloadComments={loadComments} />
            {#if comment.author !== undefined}
                <!--It is currently not possible to answer to deleted comments-->
                <button class="btn btn-secondary" on:click={() => {replyToComment(comment.comment_id, comment.content)}}><i class="fas fa-reply me-1"></i> Antworten</button>
            {/if}
        </div>
        {#each comment.answers as answer, index}
            <div class="d-flex flex-row">
                <div class="px-3 py-1 flex-shrink-1">
                    <i class="fas fa-reply"></i>
                </div>
                <div class="bg-light rounded p-3 mb-3 w-100">
                    <CommentContent {model_root} comment={answer} reloadComments={loadComments} />
                </div>
            </div>
        {/each}
    {/each}

    <CommentFormComponent {model_root} {cid} {answerToComment} reloadComments={loadComments} />
{/if}
